(function (window, document, undefined) {
  ("use strict");

  let Vue = window.Vue || false,
    logger;

  /**
   * Initialize.
   * Check if Vue is available, get the widget data and start rendering.
   *
   * @return {undefined}
   */
  const init = () => {
    try {
      logger = new window.RussMedia.Utils.Logger("[weather][singlerow] ");
    } catch (e) {
      logger = { log: function () {} };
    }

    if (!Vue) {
      logger.log("_init: No Vue!");
      return;
    }

    const weatherWidgets = document.querySelectorAll(".vodl-weather-singlerow");

    if (weatherWidgets && weatherWidgets.length > 0) {
      weatherWidgets.forEach((weatherWidget) => {
        let widgetData = parseWidgetData(weatherWidget);
        renderWidget(weatherWidget, widgetData);
      });
    }
  };

  /**
   * Render each widget.
   *
   * @return {undefined}
   */
  const renderWidget = (weatherWidget, widgetData) => {
    logger.log(weatherWidget);
    logger.log(widgetData);

    if (!weatherWidget) {
      logger.log("renderWidget: No widget node.");
      return;
    }

    if (!widgetData) {
      logger.log("renderWidget: No widget data.");
      return;
    }

    const rawData = widgetData.prefetchedRawData || [];
    if (!rawData) {
      logger.log("renderWidget: No rawData.");
      return;
    }

    const widgetId = weatherWidget.id;
    if (!widgetId) {
      logger.log("_init: No widget id.");
      return;
    }

    Vue.createApp({
      components: {
        WeatherWidget: window["@russmedia-frontend/np-widgets"].WeatherWidget,
      },
      setup() {
        const widgetProps = Vue.ref({
          dynamic: widgetData.dynamic || false,
          prefetchedRawData: rawData,
          layout: "SINGLEROW",
          townshipKey: widgetData.townshipKey || null,
          regionKey: widgetData.regionKey || null,
        });

        if (widgetData.link) widgetProps.value.link = widgetData.link;
        if (widgetData.linkText) widgetProps.value.linkText = widgetData.linkText;

        return {
          widgetProps
        };
      },
      template: `<WeatherWidget v-bind="widgetProps"></WeatherWidget>`,
    }).mount("#" + widgetId);

  };

  /**
   * Grab the JSON that should be provided in the page and parse it.
   *
   * @return {object|boolean} The widget data object on success, false otherwise.
   */
  const parseWidgetData = function (widget) {
    const widgetDataNode = widget.querySelector(
      'script[type="application/json"]'
    );

    let parsedWidgetData = {};

    try {
      parsedWidgetData = JSON.parse(widgetDataNode.innerHTML) || false;
    } catch (e) {
      return false;
    }

    return parsedWidgetData;
  };

  init();
})(window, document);
